export const rootPaths = {
    error: 'error',
    update: 'update',
};

export const terminalChildRoutePaths = {
    crop: 'crop',
    generic: 'generic',
    hardReset: 'hard-reset',
    harvest: 'harvest',
    resultMeasurement: 'result-measurement',
    home: '',
    scanFlow: 'scan-flow',
    settings: 'settings',
    setup: 'setup',
    signin: 'signin',
};

export const absoluteRoutePaths = {
    crop: '/' + terminalChildRoutePaths.crop,
    error: '/' + rootPaths.error,
    generic: '/' + terminalChildRoutePaths.generic,
    hardReset: '/' + terminalChildRoutePaths.hardReset,
    harvest: '/' + terminalChildRoutePaths.harvest,
    resultMeasurement: '/' + terminalChildRoutePaths.resultMeasurement,
    home: '/' + terminalChildRoutePaths.home,
    scanFlow: '/' + terminalChildRoutePaths.scanFlow,
    settings: '/' + terminalChildRoutePaths.settings,
    setup: '/' + terminalChildRoutePaths.setup,
    signin: '/' + terminalChildRoutePaths.signin,
    update: '/' + rootPaths.update,
};
